// @flow

import React from 'react';

const DemoInfoBox = () => {
  return (
    <div className="callout warning">
      <div className="f-bold">Demoläge/Visningsläge</div>
      <p>
      Du är inloggad i ett visningsläge för det aktuella bostadsprojektet, det ger en överblick över tillvalssystemet och det aktuella produktsortimentet. Observera att utbudet kan variera när man sedan som kund loggar in på sin specifika lägenhet, möjliga tillval är då anpassade efter lägenhetens placering, utformning och storlek.
      Vi reserverar oss för utgående produkter samt pris- och fabrikatändringar. Färgåtergivning kan variera.
      </p>
    </div>
  );
};

export default DemoInfoBox;



// WEBPACK FOOTER //
// ./src/components/DemoInfoBox/DemoInfoBox.js